
var tabsLess = {};
import genaration from '../../utils/classname';
export var tabsClass = genaration(tabsLess, 'tabs');